import Vue from 'vue'
import 'normalize.css/normalize.css' // A modern alternative to CSS resets
import './utils/registerComponent' //自动注册全局组件
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import '@/styles/index.scss' // global css
import App from './App.vue'
import store from './store'
import router from './router'

import '@/icons' // icon

// import './assets/iconfont/iconfont.css'
import Bus from '@/utils/bus'
import preventReClick from './directive/preventReClick'

Vue.use(preventReClick)
/**
 * If you don't want to use mock-server
 * you want to use MockJs for mock api
 * you can execute: mockXHR()
 *
 * Currently MockJs will be used in the production environment,
 * please remove it before going online ! ! !
 */
if (process.env.NODE_ENV === 'production') {
  const { mockXHR } = require('../mock')
  mockXHR()
}

Vue.use(ElementUI)
Vue.config.productionTip = false

new Vue({
  store,
  router,
  render: (h) => h(App),
  data: {
    bus: Bus,
  },
}).$mount('#app')
